
export interface AffectedMeditation {
  playerName: string;
  color: string;
}

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Chakra',
  data() {
    return {
      numberOfPlayer: 2,
      playerNames: [] as Array<string>,
      meditationColors: [
        'Violet',
        'Bleu',
        'Cyan',
        'Vert',
        'Jaune',
        'Orange',
        'Rouge',
      ],
      affectedMeditation: [] as Array<AffectedMeditation>,
    };
  },
  computed: {
    isValidForm(): boolean {
      return (
        this.playerNames.length === this.numberOfPlayer &&
        this.playerNames.every(
          (playerName) => playerName?.trim()?.length > 0 && playerName !== null,
        )
      );
    },
    isAvailableResult(): boolean {
      return this.affectedMeditation.length > 0;
    },
  },
  methods: {
    affectMeditation(): void {
      this.resetAffectedMeditation();
      this.playerNames.forEach((playerName) => {
        const idx = Math.floor(Math.random() * this.meditationColors.length);
        const color: string = this.meditationColors[idx];
        this.affectedMeditation.push({
          playerName,
          color,
        });
      });
    },
    resetAffectedMeditation(): void {
      this.affectedMeditation = [];
    },
  },
});
